// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "UserCreateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { UserInviteMode } from "./user-invite-mode.enum.gen";
import { PasswordDataGenShape } from "./password-data.gen";
import { Role } from "./role.enum.gen";

export const UserCreateDtoGenShape = z.strictObject({
  email: z.string(),
  inviteMode: z.enum(UserInviteMode),
  password: PasswordDataGenShape.optional(),
  teamId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  jobTitle: z.string(),
  phoneNumber: z.string(),
  roles: z.array(z.enum(Role)),
});
